module.exports = (__webpack_require__("dll-reference lib_dll"))(876);